// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js??ref--6-oneOf-0-1!../../../../../postcss-loader/dist/cjs.js!../clickable.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchTrigger-root-oC1 {\n    transition-property: color;\n    transition-duration: 224ms;\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n\n.searchTrigger-label-T-u {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "searchTrigger-root-oC1 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["root"] + " h-lg w-lg sm_w-auto",
	"label": "searchTrigger-label-T-u hidden sm_inline sm_ml-1"
};
export default ___CSS_LOADER_EXPORT___;
